import dayjs from 'dayjs'
/**
 * @name COMMON_REG
 * @desc 常用的正则
 * */

//  /^(?:(?:\+|00)86)?1[3-9]\d{9}$/
// /^\d{3}-\d{8}$|^\d{4}-\d{7,8}$/
export const COMMON_REG = {
    tellPhone: /^0\d{2}\d{8}$|^0\d{3}\d{7,8}$|^1[3-9]\d{9}$/,
    mobilePhoneReg: /^1[3-9]\d{9}$/,
    password:  /^[a-zA-Z0-9]{8,30}$/, // 密码不能是中文特殊字符,且至少8位以上
    chineseReg: /^[\u4e00-\u9fa5]+$/,
    idCard: /(^\d{15}$)|(^\d{17}([0-9]|X))$/i,
    name: /([a-zA-Z]|[\u4e00-\u9fa5]|[0-9])+/,
    cName: /^([\u4e00-\u9fa5]|[\u4dae]){2,6}(?:(·|•)([\u4e00-\u9fa5]|[\u4dae]){2,6})*$/,
    trim: /^\s+|\s+$/,
    email: /.+@.+\..+/,
    zipcode: /^[1-9]\d{5}$/,
    imei: /^86\d{13}$/,
    tel: /\d+[0-9-]+\d+/g
}

/**
 * @name CHECK_PWD
 * @desc 校验验证
 * @param {string} password
 * @return {boolean}
 * */
 export function CHECK_PWD(pwd = '') {
  return COMMON_REG.password.test(pwd)
}

/**
 * @name CHECK_TELL_PHONE
 * @desc 校验座机手机号
 * @param {string} phone
 * @return {boolean}
 * */
export function CHECK_TELL_PHONE(phone = '') {
    return COMMON_REG.tellPhone.test(phone)
}

/**
 * @name CHECK_MOBILE_PHONE
 * @desc 校验手机号
 * @param {string} phone
 * @return {boolean}
 * */
export function CHECK_MOBILE_PHONE(phone = '') {
    return COMMON_REG.mobilePhoneReg.test(phone)
}

/**
 * @name CHECK_EMAIL
 * @desc 邮箱
 * @param {string} val
 * @return {boolean}
 * */
export function CHECK_EMAIL(val) {
    return /^([a-zA-Z0-9_.-])+@(([a-zA-Z0-9-])+\.)+([a-zA-Z0-9]{2,4})+$/.test(val)
}

/**
 * @name CHECK_ID
 * @desc 身份证合法校验
 * @param socialNo
 * @return boolean
 */

export function CHECK_ID(socialNo = '') {
    if (socialNo === '') {
        return false
    }
    if (socialNo.length !== 18) {
        return false
    }
    let area = {
        11: '北京',
        12: '天津',
        13: '河北',
        14: '山西',
        15: '内蒙古',
        21: '辽宁',
        22: '吉林',
        23: '黑龙江',
        31: '上海',
        32: '江苏',
        33: '浙江',
        34: '安徽',
        35: '福建',
        36: '江西',
        37: '山东',
        41: '河南',
        42: '湖北',
        43: '湖南',
        44: '广东',
        45: '广西',
        46: '无锡',
        50: '重庆',
        51: '四川',
        52: '贵州',
        53: '云南',
        54: '西藏',
        61: '陕西',
        62: '甘肃',
        63: '青海',
        64: '宁夏',
        65: '新疆',
        71: '台湾',
        81: '香港',
        82: '澳门',
        91: '国外'
    }
    if (area[parseInt(socialNo.substr(0, 2))] == null) {
        return false
    }
    if (socialNo.length === 15) {
        let pattern = /^\d{15}$/
        if (pattern.exec(socialNo) == null) {
            return false
        }
        let birth = parseInt('19' + socialNo.substr(6, 2))
        let month = socialNo.substr(8, 2)
        let day = parseInt(socialNo.substr(10, 2))
        switch (month) {
            case '01':
            case '03':
            case '05':
            case '07':
            case '08':
            case '10':
            case '12':
                if (day > 31) {
                    return false
                }
                break
            case '04':
            case '06':
            case '09':
            case '11':
                if (day > 30) {
                    return false
                }
                break
            case '02':
                if ((birth % 4 === 0 && birth % 100 !== 0) || birth % 400 === 0) {
                    if (day > 29) {
                        return false
                    }
                } else {
                    if (day > 28) {
                        return false
                    }
                }
                break
            default:
                return false
        }
        let nowYear = new Date()
        let year = nowYear.getFullYear()
        return !(year - birth < 15 || year - birth > 100)
    }
    let Wi = [7, 9, 10, 5, 8, 4, 2, 1, 6, 3, 7, 9, 10, 5, 8, 4, 2, 1]
    let lSum = 0
    let nNum = 0
        // let nCheckSum = 0;
    for (let i = 0; i < 17; ++i) {
        if (socialNo.charAt(i) < '0' || socialNo.charAt(i) > '9') {
            return false
        } else {
            nNum = socialNo.charAt(i) - '0'
        }
        lSum += nNum * Wi[i]
    }
    if (socialNo.charAt(17) === 'X' || socialNo.charAt(17) === 'x') {
        lSum += 10 * Wi[17]
    } else if (socialNo.charAt(17) < '0' || socialNo.charAt(17) > '9') {
        return false
    } else {
        lSum += (socialNo.charAt(17) - '0') * Wi[17]
    }
    return lSum % 11 === 1
}

/**
 * @name CHECK_BIRTH_ID
 * @desc 校验出生证 出生证规则是 字母+9位数字
 * @param {string} num
 * @return {boolean}
 * */
export function CHECK_BIRTH_ID(num = '') {
    return /^[a-zA-Z]{1}[0-9]{9}$/.test(num)
}

/**
 * @name CHECK_PASSPORT
 * @desc 校验护照 8为字符（字母数字）以上
 * @param {string} num
 * @return {boolean}
 * */
export function CHECK_PASSPORT(num = '') {
    return /^[a-zA-Z0-9]{8,}$/.test(num)
}

/**
 * @name CHECK_OFFICER
 * @desc 校验军官证 10 - 18 位字符
 * @param {string} num
 * @return {boolean}
 */

export function CHECK_OFFICER(num = '') {
    return /^[a-zA-Z0-9]{10,18}$/.test(num)
}

/**
 * @name CHECK_SOLDIER
 * @desc 校验士兵证 10 - 18 位字符
 * @param {string} num
 * @return {boolean}
 * */
export function CHECK_SOLDIER(num = '') {
    return /^[a-zA-Z0-9]{10,18}$/.test(num)
}

/**
 * @name CHECK_HK_MACAO
 * @desc 校验 港澳通行证 港澳回乡证 H + 8位数字   || M + 8位数字
 * @param {string} num
 * @return {boolean}
 * */
export function CHECK_HK_MACAO(num = '') {
    return /^H[0-9]{8}$/.test(num) || /^M[0-9]{8}$/.test(num)
}

/**
 * @name CHECK_TW
 * @desc 校验 台胞证 8位数字
 * @param {string} num
 * @return {boolean}
 * */
export function CHECK_TW(num = '') {
    return /^[0-9]{8}$/.test(num)
}

/**
 * @name CHECK_HK_MACAO_TW
 * @desc 校验 港澳台居民居住证
 * 规则说明：
 * 只接受18位
 * 首6位810000，820000，830000
 * @param {string} num
 * @return {boolean}
 * **/

export function CHECK_HK_MACAO_TW(num = '') {
    return /^8[123]0000[a-zA-Z0-9]{12}$/.test(num)
}

/**
 * @name CHECK_FOREIGN_STAY
 * @desc  外国人永久居留身份证 15位：英文字母+数字（前三位必须为英文字母）
 * @param {string} num
 * @return {boolean}
 * */
export function CHECK_FOREIGN_STAY(num) {
    return /^[a-zA-Z]{3}[a-zA-Z0-9]{12}$/.test(num)
}

/**
 * @name CHECK_NAME
 * @desc 校验投被保人姓名
 * @param {string} name
 * @return {boolean}
 * */
export function CHECK_NAME(name = '') {
    const reg = /^([\p{Unified_Ideograph}·]){2,20}$/u
    const res2 = /^·/
    const res3 = /·$/
    const res4 = /·{2,}/
        // return reg.test(name)
    return (
        reg.test(name) && !res2.test(name) && !res3.test(name) && !res4.test(name)
    )
}

/**
 * @name CHECK_BANK_CARD
 * @desc 校验银行卡号
 * @param {string} str
 * @return {boolean}
 * */
export function CHECK_BANK_CARD(str = '') {
    return /^[1-9]\d{14,18}$/.test(str)
}

/**
 * @name CHECK_BIRTHDAY_BEFORE_18
 * @desc 校验是否大于18
 * @param {string} birth
 * @return {boolean}
 **/

export function CHECK_BIRTHDAY_BEFORE_18(birth) {
    return dayjs(dayjs(birth).format('YYYY/MM/DD')).isBefore(
        dayjs()
        .subtract(18, 'year')
        .format('YYYY/MM/DD')
    )
}
// 校验日期之间得年份差
export function durationYear(beforeDate, oldDate) {
    let date = dayjs(oldDate)
    return date.diff(beforeDate, 'year')
}

/**
 * @name CHECK_BACK_CARD
 * @desc 校验回乡证
 * @param {string} num
 * @return {boolean}
 * */
export function CHECK_BACK_CARD(num = '') {
    return /^[A-Z,a-z,0-9]{8,20}$/g.test(num)
}

/**
 * @name CHECK_PASSPORT_CARD
 * @desc 校验护照 数字+字母+. 组合(7~13位数)   ，字母和.为非必须
 * @param {string} num
 * @return {boolean}
 * */
export function CHECK_PASSPORT_CARD(num = '') {
    // return /^[a-zA-Z0-9\\.]{7,13}$/.test(num)
    return /^(?!\.)(?!.*\.$)(?!.*?\.{2})(?=.*\d)[A-Za-z0-9_.]{7,13}$/.test(num)
}

// 获取url地址参数
export const getUrlParams = (query) => { // 不传name返回所有值，否则返回对应值
    var url = window.location.search;
    if (url.indexOf('?') == 1) { return false; }
    url = url.substr(1);
    url = url.split('&');
    var name = query || '';
    var nameres;
    // 获取全部参数及其值
    for (var i = 0; i < url.length; i++) {
      var info = url[i].split('=');
      var obj = {};
      obj[info[0]] = decodeURI(info[1]);
      url[i] = obj;
    }
    // 如果传入一个参数名称，就匹配其值
    if (name) {
      // eslint-disable-next-line no-redeclare
      for (var i = 0; i < url.length; i++) {
        for (const key in url[i]) {
          if (key == name) {
            nameres = url[i][key];
          }
        }
      }
    } else {
      nameres = url;
    }
    // 返回结果
    return nameres;
  }

  //根据身份证号获取年龄
export function GetBirthdayTime(identityCard) {
    let strBirthday = "";
    //处理18位的身份证号码从号码中得到生日和性别代码
    strBirthday =
    identityCard.substr(6, 4) +
     "-" +
    identityCard.substr(10, 2) +
    "-" +
    identityCard.substr(12, 2);
    console.log('strBirthday', strBirthday)
    return strBirthday;
    }